export function removeDuplicatedItemsById<T>(array: T[], key: string): T[] {
  const keyType = key as keyof T;
  return array.filter(
    (n, i) => array?.findIndex(t => t[keyType] === n[keyType]) === i
  );
}
